/* eslint-disable react/prop-types */
import React, { useEffect, useContext, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import moment from 'moment';
import 'moment/locale/fi';
import 'moment/locale/sv';
import API from 'constants/api';
import { fetchMetadata, resToJsonHandleErrors } from 'helpers/actionHelpers';
import LocaleContext from 'constants/localization';
import FieldDisplay from 'field/display/FieldDisplay';

const CalendarView = () => {
  const LS = useContext(LocaleContext);
  const [reminders, setReminders] = useState([]);
  const lang = LS.getLanguage();
  moment.locale(lang);
  const localizer = momentLocalizer(moment);

  const queryRemindersForMonth = date => {
    fetch(`${API.UI.CALENDAR}?month=${date}`)
      .then(resToJsonHandleErrors)
      .then(reminders => setReminders(reminders))
      .catch(e => console.log(e));
  };

  useEffect(() => queryRemindersForMonth(new Date().toISOString().slice(0, 10)), []);

  const onNavigate = date => queryRemindersForMonth(date.toISOString().slice(0, 10));


  let messages = {}
  if(lang === 'fi'){
    messages = {
      next: 'Seuraava',
      previous: 'Edellinen',
      today: 'Tänään'
    };
  }else if(lang === 'sv'){
    messages = {
      next: 'Nästa',
      previous: 'Tidigare',
      today: 'I dag'
    };
  }

  return (
    <Calendar
      components={{ event: Reminder }}
      views={{ month: true }}
      localizer={localizer}
      events={reminders}
      startAccessor="date"
      endAccessor="date"
      onNavigate={onNavigate}
      titleAccessor="subject"
      popup={true}
      style={{ height: 500 }}
      messages={messages}
    />
  ); 
};

const Reminder = ({ event }) => {
  const LS = useContext(LocaleContext);
  const [object, setObject] = useState({});

  useEffect(() => {
    fetchMetadata(`${API.UI.IMPORTANT_INFO}&uri=${event.objectUri}`)
      .then(object => setObject(object));
  }, [event]);

  const { subject, text, objectUri } = event;

  const ReminderPopOver = (
    <Popover id="popover-basic">
      <Popover.Title as="h3">{subject}</Popover.Title>
      <Popover.Content>
        <td style={{fontSize: '14px'}}>
          {
            object?.fields && object.fields.map((field, index) => (
              <FieldDisplay field={field} key={index} />
            ))
          }
        </td>
        <p className='calendar-text'>{text}</p>
        <a href={`${API.DAM.INDEX}?main_action=${API.DAM.DISPLAY_OBJECT}?uri=${objectUri}`}
          target="_blank" className="action-link" rel="noreferrer">
          {LS.actions.open}
        </a>
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger trigger="click" placement="bottom" overlay={ReminderPopOver}>
      <div>{subject}</div>
    </OverlayTrigger>
  );
};

export default CalendarView;